import $ from 'jquery';
import pageScripts from './pages';

require( '../../../superunie-topmerken/assets/scripts/main' )

$( document ).ready( function () {
    //Require all components here.
    require('./components/popup')
    require('./components/filters')
    require('./components/header')

    document.body.className.replace(/-/g, '_').split(/\s+/).forEach(cls => {
        pageScripts[cls] && pageScripts[cls]();
    });
} );
